module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAA9CAYAAADF2cvLAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACGSURBVHgB7dDLCYBAEATR9hOQIRmKmTipGJnungTBXbzMjFAFfX+0RO0m5WgvW8qOWfFVzKokVcz5WCpMGOgNEwJqYdxBPYzJMTBgwIABAwYMGDBgwIBJgBn1vYoa5FzvpR3U31HugQIFSqCSo0ygQIECBQpUGCokUzKQGqjQTMlANdON2S68lLnVIriNqAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-ar-left-blk.png
// module id = LKzu
// module chunks = 19